
import { useCallback } from 'react';

// Simple event system for AI agent sidebar actions
const aiAgentSidebarEventListeners: { [key: string]: (() => void)[] } = {};

export const useAIAgentSidebarActions = () => {
  const emit = useCallback((event: string) => {
    const listeners = aiAgentSidebarEventListeners[event] || [];
    listeners.forEach(listener => listener());
  }, []);

  const subscribe = useCallback((event: string, callback: () => void) => {
    if (!aiAgentSidebarEventListeners[event]) {
      aiAgentSidebarEventListeners[event] = [];
    }
    aiAgentSidebarEventListeners[event].push(callback);

    // Return unsubscribe function
    return () => {
      const listeners = aiAgentSidebarEventListeners[event];
      if (listeners) {
        const index = listeners.indexOf(callback);
        if (index > -1) {
          listeners.splice(index, 1);
        }
      }
    };
  }, []);

  return { emit, subscribe };
};
